import axios from '@/app/axios'
import Competence from '@/competences/entities/competence'

class EvaluationCompetencesService {
  public async createAndLinkAsync(eId: string, entity: Competence) {
    await axios.post<Competence[]>(`evaluationcompetences/createandlink/${eId}`, entity)
  }

  public async linkAsync(eId: string, coId: string) {
    await axios.post<Competence[]>(`evaluationcompetences/link/${eId}/${coId}`)
  }
}

export default new EvaluationCompetencesService()
